<template>
  <div class="add-contract-container">
    <el-card class="box-card">
      <div v-if="!embedded" slot="header" class="figma-card-header">
        <div class="figma-page-title">
          <span class="title-prefix">起草合同</span>
          <i class="el-icon-arrow-right"></i>
          <span class="title-main">{{ addContractInfo.parentContractCode ? $t('contract.renewContract') : $t('contract.draftContract') }}</span>
        </div>
        <el-button class="figma-btn-back" @click="_goBack">返回</el-button>
      </div>

      <el-form ref="form" :model="addContractInfo" label-width="120px" class="text-left" :rules="rules">
        <!-- Parent Contract Info -->
        <el-row v-if="addContractInfo.parentContractCode" :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.parentContractName')">
              <el-input v-model="addContractInfo.parentContractName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.parentContractCode')">
              <el-input v-model="addContractInfo.parentContractCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.parentContractStatus')">
              <el-input v-model="addContractInfo.parentStateName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Basic Contract Info -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.contractName')" prop="contractName" required>
              <el-input v-model="addContractInfo.contractName"
                :placeholder="$t('contract.requiredContractName')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.contractCode')" prop="contractCode" required>
              <el-input v-model="addContractInfo.contractCode"
                :placeholder="$t('contract.requiredContractCode')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.contractType')" prop="contractType" required>
              <el-select v-model="addContractInfo.contractType" :placeholder="$t('contract.requiredContractType')"
                style="width:100%" @change="_changeContractType">
                <el-option v-for="item in addContractInfo.contractTypes" :key="item.contractTypeId" :label="item.typeName"
                  :value="item.contractTypeId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Party A Info -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyA')" prop="partyA" required>
              <el-select v-model="addContractInfo.partyA" :placeholder="$t('contract.requiredPartyA')" style="width:100%"
                @change="_changeContractPartyA">
                <el-option v-for="item in addContractInfo.contractPartyAs" :key="item.partyA" :label="item.partyA"
                  :value="item.partyA">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyAContact')" prop="aContacts" required>
              <el-input v-model="addContractInfo.aContacts" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyAPhone')" prop="aLink" required>
              <el-input v-model="addContractInfo.aLink" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Party B Info -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyB')" prop="partyB" required>
              <el-input v-model="addContractInfo.partyB" disabled style="width:70%"></el-input>
              <el-button type="primary" size="small" @click="_searchOwner">{{ $t('contract.select') }}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyBContact')" prop="bContacts" required>
              <el-input v-model="addContractInfo.bContacts" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.partyBPhone')" prop="bLink" required>
              <el-input v-model="addContractInfo.bLink" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Operator Info -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.operator')" prop="operator" required>
              <el-input v-model="addContractInfo.operator" :placeholder="$t('contract.requiredOperator')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.operatorPhone')" prop="operatorLink" required>
                <el-input v-model="addContractInfo.operatorLink" :placeholder="$t('contract.requiredOperatorPhone')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.contractAmount')">
              <el-input v-model="addContractInfo.amount" :placeholder="$t('contract.requiredContractAmount')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Time Info -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('contract.startTime')" prop="startTime" required>
              <el-date-picker v-model="addContractInfo.startTime" type="date" value-format="yyyy-MM-dd" style="width:100%"
                :placeholder="$t('contract.requiredStartTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.endTime')" prop="endTime" required>
              <el-date-picker v-model="addContractInfo.endTime" type="date" value-format="yyyy-MM-dd" style="width:100%"
                :placeholder="$t('contract.requiredEndTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('contract.signingTime')" prop="signingTime" required>
              <el-date-picker v-model="addContractInfo.signingTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"
                :placeholder="$t('contract.requiredSigningTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Contract Specs -->
        <div v-for="(item, index) in addContractInfo.contractTypeSpecs" :key="index">
          <el-row :gutter="20" v-if="index % 3 == 0">
            <el-col :span="8" v-for="i in 3" :key="i">
              <el-form-item :label="addContractInfo.contractTypeSpecs[index + i - 1].specName"
                v-if="index + i - 1 < addContractInfo.contractTypeSpecs.length">
                <el-input v-model="addContractInfo.contractTypeSpecs[index + i - 1].value"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- Contract Attachments -->
        <el-form-item :label="$t('contract.contractAttachments')">
          <el-button type="primary" @click="addFileStep">
            <i class="el-icon-plus"></i>{{ $t('contract.addAttachment') }}
          </el-button>
          <div v-for="(item, index) in addContractInfo.contractFilePo" :key="index" style="margin-top:10px">
            <el-row>
              <el-col :span="2">
                <span>{{ $t('contract.attachment') }}{{ index + 1 }}</span>
              </el-col>
              <el-col :span="10">
                <input type="file" @change="getFile($event, index)" accept=".png,.pdf,.jpg">
              </el-col>
              <el-col :span="10">
                <span>{{ item.fileRealName }}</span>
              </el-col>
              <el-col :span="2">
                <el-button type="text" @click="deleteStep(item)">{{ $t('contract.deleteAttachment') }}</el-button>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- Related Rooms -->
    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="figma-room-header">
        <span class="figma-section-title">{{ $t('contract.relatedRooms') }}</span>
        <el-button class="figma-btn-add" type="primary" size="small" @click="_selectRoom">
          <i class="el-icon-plus"></i>{{ $t('contract.add') }}
        </el-button>
      </div>

      <el-table :data="addContractInfo.rooms" border style="width:100%">
        <el-table-column prop="floorNum" :label="$t('contract.room')" align="center">
          <template slot-scope="scope">
            {{ scope.row.floorNum }}-{{ scope.row.unitNum }}-{{ scope.row.roomNum }}
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" :label="$t('contract.owner')" align="center"></el-table-column>
        <el-table-column prop="link" :label="$t('contract.phone')" align="center"></el-table-column>
        <el-table-column prop="builtUpArea" :label="$t('contract.builtUpArea')" align="center">
          <template slot-scope="scope">
            {{ scope.row.builtUpArea }}{{ $t('contract.squareMeter') }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('contract.roomStatus')" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="_openDelRoomModel(scope.row)">{{ $t('common.delete')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Approvers -->
    <div v-show="addContractInfo.audit == '1001'">
      <purchase-approvers ref="purchaseApprovers" flow-type="50005" @notify3="handleNotify"></purchase-approvers>
    </div>

    <!-- Buttons -->
    <div class="figma-bottom-bar">
      <el-button class="figma-btn-cancel" @click="_goBack">{{ $t('common.back') }}</el-button>
      <el-button class="figma-btn-submit" type="primary" @click="saveContractInfo">{{ $t('common.submit') }}</el-button>
    </div>

    <!-- Modals -->
    <search-room ref="searchRoom" @chooseRoom="handleChooseRoom"></search-room>
    <search-owner ref="searchOwner" @chooseOwner="handleChooseOwner"></search-owner>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveContract, queryContractType, queryContractPartya, queryContractTypeSpec, queryContractRoom } from '@/api/contract/addContractApi'
import PurchaseApprovers from '@/components/contract/purchaseApprovers'
import SearchRoom from '@/components/room/searchRoom'
import SearchOwner from '@/components/owner/SearchOwner'
import { uploadFile } from '@/api/system/paymentPoolApi'

export default {
  name: 'AddContractList',
  components: {
    PurchaseApprovers,
    SearchRoom,
    SearchOwner
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addContractInfo: {
        contractId: '',
        contractName: '',
        contractCode: '',
        contractType: '',
        partyA: '',
        partyB: '',
        aContacts: '',
        bContacts: '',
        aLink: '',
        bLink: '',
        operator: '',
        operatorLink: '',
        amount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        contractTypes: [],
        contractTypeSpecs: [],
        objType: '1111',
        objId: '-1',
        contractParentId: '',
        parentContractCode: '',
        parentContractName: '',
        parentStateName: '',
        rooms: [],
        contractFilePo: [],
        tempfile: '',
        contractPartyAs: [],
        audit: '',
        staffName: '',
        nextUserId: ''
      },
      communityId: '',
      rules: {
        contractName: [{ required: true, message: this.$t('contract.requiredContractName'), trigger: 'blur' }],
        contractCode: [{ required: true, message: this.$t('contract.requiredContractCode'), trigger: 'blur' }],
        contractType: [{ required: true, message: this.$t('contract.requiredContractType'), trigger: 'blur' }],
        operator: [{ required: true, message: this.$t('contract.requiredOperator'), trigger: 'blur' }],
        operatorLink: [{ required: true, message: this.$t('contract.requiredOperatorPhone'), trigger: 'blur' }],
        amount: [{ required: true, message: this.$t('contract.requiredContractAmount'), trigger: 'blur' }],
        startTime: [{ required: true, message: this.$t('contract.requiredStartTime'), trigger: 'blur' }],
        endTime: [{ required: true, message: this.$t('contract.requiredEndTime'), trigger: 'blur' }],
        signingTime: [{ required: true, message: this.$t('contract.requiredSigningTime'), trigger: 'blur' }],
        partyA: [{ required: true, message: this.$t('contract.requiredPartyA'), trigger: 'blur' }],
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._loadAddContractType()
    this._loadAddContractParkA()
    if (this.$route.query.contractId) {
      this.addContractInfo.contractParentId = this.$route.query.contractId
      this.addContractInfo.parentContractCode = this.$route.query.contractCode
      this.addContractInfo.parentContractName = this.$route.query.contractName
      this.addContractInfo.parentStateName = this.$route.query.stateName
      this._queryRoom()
      this._listContracts()
    }
  },
  methods: {
    _loadAddContractType() {
      queryContractType({ page: 1, row: 100 }).then(response => {
        this.addContractInfo.contractTypes = response.data
      })
    },
    _loadAddContractParkA() {
      queryContractPartya({ page: 1, row: 100 }).then(response => {
        this.addContractInfo.contractPartyAs = response.data
      })
    },
    _changeContractType() {
      this.addContractInfo.contractTypes.forEach(item => {
        if (this.addContractInfo.contractType == item.contractTypeId) {
          this.addContractInfo.audit = item.audit
        }
      })

      this.addContractInfo.contractTypeSpecs = []
      queryContractTypeSpec({
        page: 1,
        row: 100,
        contractTypeId: this.addContractInfo.contractType
      }).then(response => {
        response.data.forEach(item => {
          item.value = ''
          if (item.specShow == 'Y') {
            item.values = []
            this.addContractInfo.contractTypeSpecs.push(item)
          }
        })
      })
    },
    _queryRoom() {
      queryContractRoom({
        contractId: this.$route.query.contractId,
        page: 1,
        row: 100
      }).then(response => {
        this.addContractInfo.rooms = response.data
      })
    },
    _selectRoom() {
      this.$refs.searchRoom.open()
    },
    _searchOwner() {
      this.$refs.searchOwner.open()
    },
    handleChooseRoom(room) {
      this.addContractInfo.rooms.push(room)
    },
    handleChooseOwner(owner) {
      this.addContractInfo.partyB = owner.name
      this.addContractInfo.bContacts = owner.name
      this.addContractInfo.bLink = owner.link
      this.addContractInfo.objId = owner.ownerId
    },
    handleNotify(info) {
      this.addContractInfo.nextUserId = info.staffId
      this.addContractInfo.staffName = info.staffName
    },
    _openDelRoomModel(room) {
      this.addContractInfo.rooms = this.addContractInfo.rooms.filter(item => item.roomId != room.roomId)
    },
    addFileStep() {
      this.addContractInfo.contractFilePo.push({
        seq: this.addContractInfo.contractFilePo.length,
        fileSaveName: '',
        fileRealName: ''
      })
    },
    deleteStep(step) {
      this.addContractInfo.contractFilePo = this.addContractInfo.contractFilePo.filter(item => item.seq != step.seq)
    },
    getFile(e, index) {
      this.addContractInfo.tempfile = e.target.files[0]
      this.addContractInfo.contractFilePo[index].fileRealName = this.addContractInfo.tempfile.name
      this._importData(index)
    },
   async _importData(index) {
      console.log(index)
      const _fileName = this.addContractInfo.tempfile.name
      const _suffix = _fileName.substring(_fileName.lastIndexOf('.') + 1)
      if (!this.checkFileType(_suffix.toLowerCase())) {
        this.$message.error(this.$t('contract.invalidFileType'))
        return
      }

      const formData = new FormData()
      formData.append("uploadFile", this.addContractInfo.tempfile)
      const  data  = await uploadFile(formData, {})
      this.addContractInfo.contractFilePo[index].fileSaveName = data.realFileName
      // 这里需要实现文件上传逻辑
      // uploadContactFile(formData).then(response => {
      //   this.addContractInfo.contractFilePo[index].fileSaveName = response.data
      //   this.$message.success(this.$t('common.operationSuccess'))
      // })
    },
    checkFileType(fileType) {
      return ['png', 'pdf', 'jpg'].includes(fileType)
    },
    _changeContractPartyA() {
      const partyA = this.addContractInfo.partyA
      this.addContractInfo.contractPartyAs.forEach(item => {
        if (partyA == item.partyA) {
          this.addContractInfo.aLink = item.aLink
          this.addContractInfo.aContacts = item.aContacts
        }
      })
    },
    _listContracts() {
      // 需要实现查询合同详情逻辑
    },
    saveContractInfo() {
      if (!this.validateForm()) {
        return
      }

      this.addContractInfo.communityId = this.communityId
      saveContract(this.addContractInfo).then(response => {
        if (response.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$emit('success')
          this._goBack()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    validateForm() {
      // 实现表单验证逻辑
      return true
    },
    _goBack() {
      if (this.embedded) {
        this.$emit('back')
        return
      }
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.add-contract-container {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background: #EBF2FA;
}
.add-contract-container >>> .el-card {
  background: white;
  border-radius: 12px;
  border: none;
  margin-bottom: 20px;
}
.add-contract-container >>> .el-card__header {
  border-bottom: 1px solid #EBF2FA;
  padding: 16px 24px;
}
.add-contract-container >>> .el-card__body {
  padding: 20px 24px;
}

/* Header */
.figma-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.figma-page-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 600;
}
.figma-page-title .title-prefix {
  color: #8C9BB4;
}
.figma-page-title .title-main {
  color: #1D2129;
}
.figma-page-title i {
  color: #8C9BB4;
  font-size: 14px;
}
.figma-btn-back {
  width: 78px !important;
  height: 38px !important;
  padding: 0 !important;
  background: white !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}

/* Form */
.add-contract-container >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500;
  color: #1D2129;
  line-height: 38px;
}
.add-contract-container >>> .el-form-item.is-required .el-form-item__label::before {
  color: #FB2C36;
  font-weight: 500;
}
.add-contract-container >>> .el-input__inner,
.add-contract-container >>> .el-select .el-input__inner,
.add-contract-container >>> .el-date-editor.el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  color: #1D2129;
  background: #fff;
  padding: 0 16px;
}
.add-contract-container >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
}
.add-contract-container >>> .el-input.is-disabled .el-input__inner {
  background: #F1F6FA;
  color: #1D2129;
}
.add-contract-container >>> .el-select .el-input .el-select__caret {
  color: #364153;
}
.add-contract-container >>> .el-date-editor .el-input__prefix {
  right: 10px;
  left: auto;
}
.add-contract-container >>> .el-date-editor .el-input__inner {
  padding-left: 16px;
  padding-right: 30px;
}

/* Room Header */
.figma-room-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.figma-section-title {
  font-size: 16px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 600;
  color: #1D2129;
}
.figma-btn-add {
  width: 82px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}
.figma-btn-add >>> i {
  margin-right: 4px;
}

/* Table */
.add-contract-container >>> .el-table th {
  background: #EBF2FA;
  color: #364153;
  font-weight: 400;
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
}
.add-contract-container >>> .el-table td {
  font-size: 14px;
  color: #1D2129;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
}
.add-contract-container >>> .el-table .even-row {
  background: #F8FBFF;
}
.add-contract-container >>> .el-table--border,
.add-contract-container >>> .el-table--group {
  border: none;
}
.add-contract-container >>> .el-table--border th,
.add-contract-container >>> .el-table--border td {
  border-right: 1px solid #EBF2FA;
}
.add-contract-container >>> .el-table th.is-leaf,
.add-contract-container >>> .el-table td {
  border-bottom: 1px solid #EBF2FA;
}

/* Attachment */
.add-contract-container >>> .el-button--primary:not(.figma-btn-add):not(.figma-btn-submit) {
  height: 38px;
  padding: 0 16px;
  background: white;
  border: 1px solid #0E76FF;
  color: #0E76FF;
  border-radius: 10px;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500;
}
.add-contract-container >>> .el-button--primary:not(.figma-btn-add):not(.figma-btn-submit) >>> i {
  margin-right: 4px;
}

/* Bottom Bar */
.figma-bottom-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 20px 24px;
  background: white;
  border-radius: 12px;
}
.figma-btn-cancel {
  width: 98px !important;
  height: 38px !important;
  padding: 0 !important;
  background: white !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}
.figma-btn-submit {
  width: 98px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}

/* Action links in table */
.add-contract-container >>> .el-button--text {
  color: #0E76FF;
}
.add-contract-container >>> .el-button--danger {
  background: white;
  border: 1px solid #F56C6C;
  color: #F56C6C;
  border-radius: 10px;
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500;
}
</style>